export default "assets/images/icons/tirelire-b6700135.svg";